import React from 'react';
import Table from '../../../../../components/_table/Table';
import Panel from '../../../../../components/outline/Panel';
import { columns } from './columns';
import { POINT_ISSUE_HISTORY_DETAIL_FILTER_OPTION_MODEL } from '../../../../../store/modules/point/models';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import './PointIssueHistoryDetailItemList.scss';

const PointIssueHistoryDetailItemList = (props) => {
  const {
    pointCauseSelectList,
    pointIssueHistoryItemList,
    getPointIssueHistoryPointLogList,
    filterOption,
    pagination,
  } = props;

  return (
    <Panel className="point-issue-history-detail-item-list">
      <div className="panel-header">
        <div className="title">포인트 발급 내역 아이템 리스트</div>
      </div>

      <div className="panel-body">
        <Table
          columns={(utils) =>
            columns({
              ...utils,
              pointCauseSelectList,
            })
          }
          rowKey={(record) => record.id}
          list={pointIssueHistoryItemList}
          getList={(option) =>
            getPointIssueHistoryPointLogList({
              ...option,
            })
          }
          filterOption={filterOption}
          pagination={pagination}
          initialOption={{
            filterOption: POINT_ISSUE_HISTORY_DETAIL_FILTER_OPTION_MODEL,
            pagination: _LIST_PAGINATION_MODEL,
          }}
          size="small"
          scroll={{ x: true }}
          bordered={true}
        />
      </div>
    </Panel>
  );
};

export default PointIssueHistoryDetailItemList;
